function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { DatePicker, Divider, Table, Alert, Button, Space, Modal, notification, Statistic, Breadcrumb } from "antd";
import { Row, Col, Container } from "react-bootstrap";
import { CheckCircleFill, XCircleFill, ClockHistory } from "react-bootstrap-icons";
import dayjs from "dayjs";
import Moment from "react-moment";
import moment from 'moment';
import Common from "../components/includes/Common";
import { Icon } from "@iconify/react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var AgentsPayments = function AgentsPayments() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPayoutTransaction = _useState2[0],
    setSelectedPayoutTransaction = _useState2[1];
  var _useState3 = useState(moment().startOf('month').format()),
    _useState4 = _slicedToArray(_useState3, 2),
    payFrom = _useState4[0],
    setPayFrom = _useState4[1];
  var _useState5 = useState(moment().endOf('month').format()),
    _useState6 = _slicedToArray(_useState5, 2),
    payTo = _useState6[0],
    setPayTo = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    deposits = _useState8[0],
    setDeposits = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    dataChanged = _useState0[0],
    setDataChanged = _useState0[1];
  var _useState1 = useState(""),
    _useState10 = _slicedToArray(_useState1, 2),
    dataError = _useState10[0],
    setDataError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    dataLoading = _useState12[0],
    setDataLoading = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    summary = _useState14[0],
    setSummary = _useState14[1];
  var rangePresets = [{
    label: "Ajourdh'ui",
    value: [dayjs().startOf('day'), dayjs()]
  }, {
    label: "Cette semaine",
    value: [dayjs().startOf('week'), dayjs().endOf('week')]
  }, {
    label: 'Ce mois',
    value: [dayjs().startOf('month'), dayjs().endOf('month')]
  }];
  var handleApproveExpense = function handleApproveExpense(t) {
    setSelectedPayoutTransaction(t);
    confirm({
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CheckCircleFill, {
          size: 28,
          color: "#3F5E36"
        }), " Confirmation de l'encaissement !"]
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Validez-vous l'encaissement de ", t.amount.toLocaleString("Fr"), " GNF demand\xE9e par ", t.user.prenom, " ", t.user.nom]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "approvedeposit", {
          cash_transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Ok!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  var handleRejectExpense = function handleRejectExpense(t) {
    setSelectedPayoutTransaction(t);
    confirm({
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(XCircleFill, {
          size: 28,
          color: "#9E2E2E"
        }), " Annulation de l'encaissement !"]
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["Confirmez-vous l'annulation de ", t.amount.toLocaleString("Fr"), " GNF demand\xE9e par ", t.user.firstname, " ", t.user.lastname]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "rejectdeposit", {
          transaction_id: t.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
          } else {
            notification.error({
              message: "Ok!",
              description: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Ok!",
            description: "Une erreur est survenue. Code: " + error.toString()
          });
        })["finally"](function () {});
      }
    });
  };
  useEffect(function () {
    setDataChanged(false);
    setDataLoading(false);
    setDataError("");
    axios.get(Common.baseApiUrl + "getdeposits/" + Common.currentUser.id + "/" + payFrom + "/" + payTo).then(function (response) {
      if (response.data.status == 200) {
        setDeposits([]);
        response.data.deposits.forEach(function (e) {
          setDeposits(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              date: e.created_at,
              agent: e.user && e.user.prenom + " " + e.user.nom,
              type: "Versement",
              amount: e.amount.toLocaleString("Fr"),
              approver: e.approver && e.approver.prenom + " " + e.approver.nom,
              status: e.status,
              action: e
            }]);
          });
        });
        setSummary(response.data.summary);
      } else {
        setDataError(response.data.message);
      }
    })["catch"](function (error) {
      setDataError("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setDataLoading(false);
    });
  }, [dataChanged, payFrom, payTo]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsx(Breadcrumb, {
          items: [{
            title: /*#__PURE__*/_jsx("span", {
              children: "ALO-GAZ"
            })
          }, {
            title: "Paiements agents"
          }]
        }), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), ContextHolder, /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 8,
        md: 7,
        children: /*#__PURE__*/_jsx(RangePicker, {
          size: "large",
          onChange: function onChange(dates, ds) {
            if (dates) {
              setPayFrom(dates[0].format());
              setPayTo(dates[1].format());
            }
          },
          format: "DD/MM/YYYY",
          allowClear: true,
          needConfirm: false,
          presets: rangePresets
        })
      })
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 4,
        md: 4,
        children: /*#__PURE__*/_jsxs("b", {
          children: ["P\xE9riode du ", /*#__PURE__*/_jsx(Moment, {
            date: payFrom,
            format: "DD/MM/YYYY"
          }), " au ", /*#__PURE__*/_jsx(Moment, {
            date: payTo,
            format: "DD/MM/YYYY"
          })]
        })
      }), /*#__PURE__*/_jsx(Col, {
        children: dataError.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: dataError,
          showIcon: true,
          banner: true
        })
      })]
    }), summary && /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            borderRadius: "7px",
            padding: "22px 18px",
            textAlign: "center",
            background: "#A8675C"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            prefix: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:sales-performance",
              width: "48",
              height: "48"
            }),
            valueStyle: {
              color: "#EEE"
            },
            title: /*#__PURE__*/_jsx("b", {
              style: {
                color: '#EEE'
              },
              children: "Total en attente"
            }),
            value: summary.total_pending
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        lg: 6,
        md: 6,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            borderRadius: "7px",
            padding: "22px 18px",
            textAlign: "center",
            background: "#A8825C"
          },
          children: /*#__PURE__*/_jsx(Statistic, {
            prefix: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:money-transfer",
              width: "48",
              height: "48"
            }),
            valueStyle: {
              color: "#EEE"
            },
            title: /*#__PURE__*/_jsx("b", {
              style: {
                color: '#EEE'
              },
              children: "Total valid\xE9"
            }),
            value: summary.total_validated
          })
        })
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx(Table, {
          size: "small",
          columns: [{
            title: /*#__PURE__*/_jsx("b", {
              children: "Date"
            }),
            dataIndex: "date",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(Moment, {
                  date: v,
                  format: "DD/MM/YYYY"
                })
              });
            },
            key: "date"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Agent"
            }),
            dataIndex: "agent",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "agent"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Montant"
            }),
            dataIndex: "amount",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "amount"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Type"
            }),
            dataIndex: "type",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v.toLocaleString('Fr')
              });
            },
            key: "type"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Approbateur"
            }),
            dataIndex: "approver",
            render: function render(v) {
              return /*#__PURE__*/_jsx("b", {
                children: v
              });
            },
            key: "approver"
          }, {
            title: /*#__PURE__*/_jsx("b", {
              children: "Status"
            }),
            dataIndex: "status",
            render: function render(v) {
              return /*#__PURE__*/_jsxs("b", {
                children: [v == 0 && /*#__PURE__*/_jsx(ClockHistory, {
                  size: 22,
                  color: "#BB8C2A"
                }), v == 1 && /*#__PURE__*/_jsx(CheckCircleFill, {
                  size: 22,
                  color: "#34C482"
                }), v == 2 && /*#__PURE__*/_jsx(XCircleFill, {
                  size: 22,
                  color: "#C46D4E"
                })]
              });
            },
            key: "status"
          }, {
            title: /*#__PURE__*/_jsx("b", {}),
            dataIndex: "action",
            render: function render(t) {
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [t.status == 0 && /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsx(Button, {
                    style: {
                      color: "#34C482"
                    },
                    onClick: function onClick() {
                      handleApproveExpense(t);
                    },
                    disabled: t.status == 1 || t.status == 2,
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(CheckCircleFill, {
                        size: 25
                      })
                    })
                  }), /*#__PURE__*/_jsx(Button, {
                    style: {
                      color: "#C46D4E"
                    },
                    onClick: function onClick() {
                      handleRejectExpense(t);
                    },
                    disabled: t.status == 2 || t.status == 1,
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(XCircleFill, {
                        size: 25
                      })
                    })
                  })]
                }), t.status == 1 && /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: /*#__PURE__*/_jsx(Button, {
                    style: {
                      color: "#34C482"
                    },
                    onClick: function onClick() {
                      handleApproveExpense(t);
                    },
                    disabled: t.status == 1 || t.status == 2,
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(CheckCircleFill, {
                        size: 25
                      })
                    })
                  })
                }), t.status == 2 && /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: /*#__PURE__*/_jsx(Button, {
                    style: {
                      color: "#C46D4E"
                    },
                    onClick: function onClick() {
                      handleRejectExpense(t);
                    },
                    disabled: t.status == 2 || t.status == 1,
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(XCircleFill, {
                        size: 25
                      })
                    })
                  })
                })]
              });
            },
            key: "acion"
          }],
          bordered: true,
          sticky: true,
          loading: dataLoading,
          dataSource: deposits,
          scroll: {
            y: 520
          }
        })
      })
    })]
  });
};
export default AgentsPayments;